/**
 * Created by emanuele on 29/05/2017.
 */
import React from 'react';
import QueryFilter from '../QueryFilter'

const QueryFilterRubrica = (props) => (
    <QueryFilter  {...props}  >
        <p>La query può essere applicata sui campi del soggetto (s.), del dipartimento (d.) o dell'organizzazione (o.)</p>
        <p>Campi utilizzabili da tutti:</p>
        <ul>
            <li>.tit</li>
            <li>.nome</li>
            <li>.cognome</li>
            <li>.sesso</li>
            <li>.indirizzo</li>
            <li>.cap</li>
            <li>.citta</li>
            <li>.provincia</li>
            <li>.stato</li>
            <li>.cfisc</li>
            <li>.email</li>
            <li>.pec</li>
            <li>.telefono1</li>
            <li>.telefono2</li>
            <li>.cellulare</li>
            <li>.fax</li>
            <li>.note</li>
        </ul>
        <p>Campi utilizzabili solo dai soggetti:</p>
        <ul>
            <li>s.tit</li>
            <li>s.cognome</li>
            <li>s.sesso</li>
        </ul>
        <p>Campi utilizzabili da dipartimenti e organizzazioni:</p>
        <ul>
            <li>.piva</li>
            <li>.web</li>
        </ul>
        <p>Operatori utilizzabili nella query:</p>
        <ul>
            <li><code>=, &#x3C;, &#x3C;=, &#x3E;, &#x3E;=, &#x3C;&#x3E;, !=, like, and, or</code></li>
        </ul>
        <p>
            <b>Esempio: </b> s.cognome = 'ROSSI' and o.nome like  '%Arezzo%' <em>(tutti i soggetti con cognome Rossi appartenenti all'Organizzazione che nel nome contiene Arezzo)</em><br/>
            <b>Esempio: </b> s.cognome = 'ROSSI' and d.citta = 'Firenze' <em>(tutti i soggetti di cognome Rossi il cui dipartimento è di Firenze)</em><br/>
        </p>
        <p>Premere il tasto di <b>conferma</b> per applicare la condizione.</p>
    </QueryFilter>
);


export default QueryFilterRubrica;


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/QueryFilterRubrica.js
 **/